import React from 'react';
import fundingSourcesModel from '../../models/fundingSourcesModel';
import ExternalReferralPage from '../erPage/ExternalReferralPage';

const FundingSources = () => {
  let model = fundingSourcesModel();

  return (
    <ExternalReferralPage
      model={model}
      dataPropertyName="fundingSources"
    ></ExternalReferralPage>
  );
};

export default FundingSources;
